import React from 'react';
import { Modal, Box, Typography, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AgendaCard from './AgendaCard'; // Criaremos abaixo

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 800,
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

function AgendaModal({ open, onClose, date, agendamentos, loading }) {
  const formattedDate = date ? new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '';

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Typography variant="h5" component="h2" gutterBottom>
          Agendamentos - {formattedDate}
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" my={5}>
            <CircularProgress />
          </Box>
        ) : (
          <Box mt={2} display="flex" flexDirection="column" gap={2}>
            {agendamentos.length > 0 ? (
              agendamentos.map(os => (
                <AgendaCard key={os._id} os={os} />
              ))
            ) : (
              <Typography>Nenhum agendamento encontrado para este dia.</Typography>
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
}

export default AgendaModal;